import React, { useState, useRef } from "react";
import { navigate } from "gatsby";
import styled from "styled-components";
import { device } from "../../styles/deviceSizes";
import { getResortUrl, computeVillaFields } from "../../lib/helpers";
import Placeholder from "../../assets/placeholder.svg";
import { Button } from "../Button";
import { Carousel } from "../Carousel";
import { ACCOMODATIONS_SECTION } from "../../constants";
import { PriceTemplate } from "../PriceTemplate";
import { Overlay } from "../Overlay";
import { GatsbySanityImage } from "../GatsbySanityImage";
import { useIsMobile } from "../../hooks";

const AccomodationStyles = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 1;
  @media ${device.tablet} {
    padding: 0;
  }

  h2 {
    text-align: center;
    /* padding: 5rem; */
    letter-spacing: normal;
    margin: 7rem 0 5rem 0;
    @media ${device.onlyMobileSm} {
      margin: 5rem 0 5rem 0;
    }
  }
  .carousel {
    z-index: 1;
    margin: 0 0;
    padding-top: 5rem;
    padding-bottom: 5rem;
    width: 100%;
    height: auto;
    @media ${device.onlyMobileSm} {
      padding: 0rem 1.5rem;
    }
    .slick-arrow {
      z-index: 1;
      top: 45%;
      ::before {
        content: unset !important;
      }
    }
    .slick-prev {
      left: 0;
      @media ${device.onlyMobile} {
        left: 1.5rem;
      }
    }
    .slick-next {
      right: 1rem;
      @media ${device.onlyMobile} {
        right: 1.5rem;
      }
    }
    .slick-slide {
      transform: scale(0.75);
      .slide-overlay {
        opacity: 0.3;
        z-index: 1;
      }
      z-index: 50;
      transition: 0.8s ease-in-out;
      :not(.slick-active) {
        cursor: pointer;
      }
      &.slick-center {
        transform: scale(1) !important;
        z-index: 100;
        .roomFooter {
          visibility: visible;
          opacity: 1;
        }
        .slide-overlay {
          opacity: 0;
          z-index: 0;
        }
      }
    }

    .slick-slide,
    .gatsby-image-wrapper {
      width: 60rem;
      @media ${device.onlyMobileSm} {
        width: 40rem;
      }
      @media ${device.tabletL} {
        width: 50rem;
      }
      @media ${device.onlyDesktopS} {
        width: 70rem;
      }
    }

    .slick-dots {
      display: block;
      font-size: 10px !important;
      /* li button::before {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: inherit;
        font-size: 2rem;
      }
      li.slick-active button::before {
        line-height: unset;
        border: 1px solid !important;
        border-radius: 50%;
      }
      top: 100%;
      left: 0;
      padding: 0 3.5rem;
      @media ${device.onlyMobileSm} {
        padding: 0 1.5rem;
        top: unset;
        bottom: -25px;
      }
      @media ${device.mobileS} {
        bottom: -5rem;
      } */
    }
    .slick-track {
      display: flex;
      align-items: baseline;
    }
  }

  .image-container {
    width: 100%;
    height: 100%;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    position: relative;
    .gatsby-image-wrapper {
      height: 450px;
      @media ${device.onlyMobileSm} {
        height: 250px;
      }
    }
    img {
      object-fit: cover;
      object-position: 100% 100%;
      width: 100%;
      height: 100%;
    }

    .roomFooter {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      position: absolute;
      margin-bottom: 1rem;
      bottom: 0;
      width: 300px;
      max-width: 300px;
      visibility: hidden;
      opacity: 0;
      transition: visibility 0s, opacity 1s linear;
      border: 1.8px solid var(--primary);
      padding: 2rem 2rem 2rem 2rem;
      background: rgb(0, 0, 0, 0.4);
      @media ${device.onlyMobileSm} {
        padding: 1rem 1rem;
        width: 210px;
      }
      span,
      p {
        color: white;
      }
      button {
        transition: border 1s linear !important;
        border-color: white;
        color: white;
        margin-top: 15px;
      }
      .roomname {
        font-size: 1.6rem;
        text-align: center;
        line-height: 2rem;
        letter-spacing: 0.3rem;
        color: white;
        cursor: pointer;
        padding-bottom: 10px;
        font-family: "rivera_light_regular", sans-serif;

        @media ${device.tablet} {
          font-size: 1.4rem;
          margin-right: 1rem;
        }
        @media ${device.onlyMobileSm} {
          text-align: left;
          font-size: 1.2rem !important;
          font-weight: 600 !important;
        }
      }
      .room-price {
        font-size: 1.4rem;
        color: #595959;
        @media ${device.onlyMobileSm} {
          font-size: 1.2rem;
        }
      }
      .content {
        width: 100%;
        height: 100%;
      }
    }
  }
  .accomodation-main-content {
    width: 100%;
    height: 100%;
  }
`;

const Accomodation = ({
  items,
  title,
  isResort,
  isRecommended,
  id,
  elementRef,
  currentSlideIndex: currentSlideIndex_,
  carouselProps,
}) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(
    currentSlideIndex_ || 0
  );
  const carouselProps_ = {
    variableWidth: true,
    centerMode: true,
    // infinite: false,
    ...carouselProps,
  };

  const isMobile = useIsMobile();
  const carouselRef = useRef();
  const afterChange = React.useCallback((current) => {
    setCurrentSlideIndex(current);
  }, []);

  if (!items?.length) return null;
  return (
    <AccomodationStyles
      id={id}
      className="resort__accomodation"
      ref={elementRef}
    >
      <div className="accomodation-main-content">
        <h2>{title}</h2>
        <div>
          <Carousel
            className={`carousel ${isRecommended ? "recommended" : ""}`}
            innerRef={carouselRef}
            dots={!isMobile}
            initialSlide={currentSlideIndex || 0}
            speed={1000}
            afterChange={afterChange}
            {...carouselProps_}
          >
            {items.map((content, villaIndex) => {
              const navState = {
                state: {
                  pageFrom: ACCOMODATIONS_SECTION,
                  currentSlideIndex,
                },
              };

              return (
                <React.Fragment key={villaIndex}>
                  <AccomodationCard
                    navState={navState}
                    isResort={isResort}
                    content={content}
                    villaIndex={villaIndex}
                    carouselRef={carouselRef}
                    totalItemsCount={items?.length}
                  />
                </React.Fragment>
              );
            })}
          </Carousel>
        </div>
      </div>
    </AccomodationStyles>
  );
};

const AccomodationCard = ({
  content,
  totalItemsCount,
  isResort,
  navState,
  villaIndex,
  carouselRef,
  currentSlideIndex,
}) => {
  if (!content) return null;
  const villa = !isResort
    ? computeVillaFields({ villa: { ...content } })
    : undefined;
  const url = !isResort
    ? villa?.villaUrl
    : getResortUrl({ shortName: content?.shortName });
  const accomodationImage = !isResort ? content?.imageThumb : content?.image;

  const viewButtonText = !isResort ? "View Room" : "View Resort";
  return (
    <div className="image-container">
      <Overlay zIndex={1} className="slide-overlay" />
      {accomodationImage && accomodationImage.asset ? (
        <GatsbySanityImage
          onClick={() => {
            const carouselRef_ = carouselRef?.current;
            if (villaIndex === 0) {
              carouselRef_?.slickGoTo(0);
            } else if (
              villaIndex > currentSlideIndex &&
              villaIndex !== totalItemsCount - 1
            ) {
              carouselRef_?.slickNext();
            } else if (currentSlideIndex > villaIndex) {
              carouselRef_?.slickPrev();
            } else {
            }
          }}
          className="image"
          gatsbyImage={accomodationImage?.asset?.gatsbyImageData}
          config={{ fit: "clip" }}
          alt={accomodationImage.alt}
        />
      ) : (
        <Placeholder />
      )}
      <div className="roomFooter">
        <h3 className="roomname" onClick={() => navigate(url, navState)}>
          {content?.name}
        </h3>
        {!isResort ? (
          <PriceTemplate
            className="room-price"
            price={villa?.villaPrice}
            priceOnRequest={content?.priceOnRequest}
          />
        ) : null}
        <Button
          onClick={() => {
            navigate(url, navState);
          }}
        >
          {viewButtonText}
        </Button>
      </div>
    </div>
  );
};

export default Accomodation;
